import React from "react";
import {
//   BrowserRouter as Router,
  useParams,
} from "react-router-dom";
import Trigonometry from './Trigonometry';
import Circles from './Circles';
import Parallelograms from './Parallelograms';
import Vectors from "./Vectors";
import ThreeDGeometry from "./ThreeDGeometry";
import Triangles from "./Triangles";
import CoordinateGeometry from "./CoordinateGeometry";
import CurvesAndCurvature from "./CurvesAndCurvature";
import Centroids from "./Centroids";

const ChangeComponents = {
    trigonometry: Trigonometry,
    circles: Circles,
    parallelograms: Parallelograms,
    vectors: Vectors,
    threedgeometry: ThreeDGeometry,
    triangles: Triangles,
    coordinategeometry: CoordinateGeometry,
    curvesandcurvature: CurvesAndCurvature,
    centroids: Centroids,

  };

export default function Subtopics(props) {
    // The <Route> that rendered this component has a
    // path of `/topics/:topicId`. The `:topicId` portion
    // of the URL indicates a placeholder that we can
    // get from `useParams()`.
    let { topicId } = useParams();
    
    let MyComponent = ChangeComponents[topicId];
    return (
        <div>
            {/* {topicId} is for testing route names */}
            {/* <h3>{topicId}</h3> */}
            <MyComponent topicId={topicId}/>
      </div>
    );
  }